import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../api/axios';


// export const fetchCurrentUserOrig = createAsyncThunk('auth/fetchCurrentUser', async () => {
//   const res = await api.get('/mvapi-ui/user/me'); 
//   console.log(res.data);
//   return res.data;
// });

export const fetchCurrentUser = createAsyncThunk(
  'auth/fetchCurrentUser',
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get('/mvapi-ui/user/me');
      const data = res.data;

      const expMs = typeof data.exp === 'number'
        ? data.exp * 1000
        : new Date(data.exp).getTime();

      return {
        email: data.email,
        groups: data.groups,
        accountIds: data.accountIds,
        defaultAccountId: data.defaultAccountId,
        expiresIn: Math.floor((expMs - Date.now()) / 1000),
      };
    } catch (err) {
      return rejectWithValue(err.response?.status ?? 'network_error');
    }
  }
);


const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: null,
    isAuthenticated: false,
    loading: true,
    error: null,
    expiresIn: null,
  },
  reducers: {
    clearUser(state) {
      state.user = null;
      state.isAuthenticated = false;
      state.loading = false;
      state.error = null;
      state.expiresIn = null;

    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCurrentUser.pending, (state) => {
        console.log('fetchCurrentUser pending');

        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCurrentUser.fulfilled, (state, action) => {
        console.log('fetchCurrentUser fulfilled:', action);

        const { expiresIn, ...user } = action.payload;
        state.user = user;         // email, groups, accountIds, defaultAccountId
        state.expiresIn = expiresIn;
        state.isAuthenticated = true;
        state.loading = false;
      })
      .addCase(fetchCurrentUser.rejected, (state, action) => {
        console.log('fetchCurrentUser rejected:', action.error);

        state.user = null;
        state.isAuthenticated = false;
        state.loading = false;
        state.error = action.error.message;
        state.expiresIn = null;
      });
  },
});

export const { clearUser } = authSlice.actions;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectUser = (state) => state.auth.user;
export const selectAuthLoading = (state) => state.auth.loading;
export const selectUserEmail = (state) => state.auth.user?.email || null;
export const selectExpiresIn = (state) => state.auth.expiresIn;
export default authSlice.reducer;
